import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../interactions/interactions';
import '../typography/typography';
import css from './navigation-link.css';

import NavigationLink from './navigation-link';

const NavigationLinkIcon = ({ icon, className, ...otherProps }) => (
  <NavigationLink
    className={classnames(className, css['ds-navigation-link--icon'], {
      [css[`ds-navigation-link--icon-${icon}`]]: icon,
    })}
    {...otherProps}
  />
);

NavigationLinkIcon.defaultProps = {
  className: null,
  icon: null,
};

NavigationLinkIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOf(['account', 'search']),
};

export default NavigationLinkIcon;
